import standardAPI from '@/api/standard_items';

const state = {
  feedback: [],
  feedback_status: '',
  feedback_MetaData: {},
  feedback_page: 1,
  feedback_perPage: 10,
};

const responseUrl = '/feedback';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_feedback ({ commit }, getOptions) {
    commit('FEEDBACK_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl + '/list/admin',
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('FEEDBACK_SUCCESS', response);
            commit('FEEDBACK_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('FEEDBACK_READY');
            reject(response);
          } else {
            commit('FEEDBACK_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_feedback ({ commit, dispatch }, itemData) {
    commit('FEEDBACK_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/leave',
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('FEEDBACK_READY');
          reject(response);
        }
      });
    });
  },
  edit_feedback ({ commit, dispatch }, itemData) {
    commit('FEEDBACK_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('FEEDBACK_READY');
          reject(response);
        }
      });
    });
  },
  remove_feedback ({ commit, dispatch }, itemData) {
    commit('FEEDBACK_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('FEEDBACK_READY');
          reject(response);
        }
      });
    });
  },
  reorder_feedback ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.feedback_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.feedback_perPage = max;
  },
  FEEDBACK_READY: (state) => {
    state.feedback_status = 'ready';
  },
  FEEDBACK_REQUEST: (state) => {
    state.feedback_status = 'loading';
  },
  FEEDBACK_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.feedback_MetaData.meta = response.meta;
      state.feedback_MetaData.links = response.links;
    }
    state.feedback = response.data;
    state.feedback_status = 'success';
  },
  FEEDBACK_ERROR: (state) => {
    state.feedback_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
